import { createContext } from 'react';

export const PostQuestionsContext = createContext({
  langKey: 'en',
  errors: {},
});
